module.exports = __webpack_public_path__ + "img/sides.801addb.jpg";